import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../auth";
import { Content, BaseShelf } from "../globalType";
import { translate } from "../utils";

const live_menu:BaseShelf = {
  id: 'live',
  setting: {
    shelf_code: 'live',
    shelf_slug: 'live',
    title_en: 'Live TV',
    title_th: 'Live TV',
    type: 'by_shelfid',
    view_type: 'vertical',
    thumb_display: undefined,
    content_provider: undefined,
    article_category: undefined,
    app_name: undefined,
    lang: undefined,
    limit: undefined,
    recommend: undefined,
  },
  shelf_items: []
}

type Props = {
  goToPage: (page: string, content: Content | null) => void;
  page: string;
  menu: BaseShelf[];
};

export function TopMenu(props: Props) {
  const { goToPage, page, menu } = props;
  const authContext = useContext(AuthContext);

  const [menus, setMenus] = useState<BaseShelf[]>([])

  useEffect(() => {
    if (menu.length > 0 && menus.length === 0) {
      const list = [...menu.slice(0, 1), {...live_menu}, ...menu.slice(1)]
      setMenus(list)
    }
  }, [menu])

  return (
    <>
    <div className="w-100 header-container">
    <div className="header-menu">
        {menus.map((shelf) => {
          //const menuCls = classNames('bold', {'active': page === 'home'})
          return (
            <div
              onClick={() => {
                goToPage(makeMenuUrl(shelf), null);
              }}
              className={makeMenuCls(shelf, page)}
            >
              {translate(
                shelf.setting.title_th,
                shelf.setting.title_en,
                authContext?.lang
              )}
            </div>
          );
        })}
      </div>
    </div>
      
    </>
  );
}

export function SubcategoryTopMenu(props: Props) {
  const { goToPage, page, menu } = props;
  const authContext = useContext(AuthContext);

  const [menus, setMenus] = useState<BaseShelf[]>([])

  useEffect(() => {
    if (menu.length > 0 && menus.length === 0) {
      const list = [...menu.slice(0, 1), {...live_menu}, ...menu.slice(1)]
      setMenus(list)
    }
  }, [menu])

  return (
    <>
      <div className="subMenu-BG">
        <div className="container H-container">
          <div className="subMenu">
            <div className="mobile">
              <img src="/ondemand/static/img/search.png" alt="" />
            </div>
            {menus.map((shelf) => {
              //const menuCls = classNames('bold', {'active': page === 'home'})
              return (
                <div
                  onClick={() => {
                    goToPage(makeMenuUrl(shelf), null);
                  }}
                  className={makeSubMenuCls(shelf, page)}
                >
                  {translate(
                    shelf.setting.title_th,
                    shelf.setting.title_en,
                    authContext?.lang
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export function CategoryTopMenu(props: Props) {
  const { goToPage, page, menu } = props;
  const authContext = useContext(AuthContext);

  const [menus, setMenus] = useState<BaseShelf[]>([])

  useEffect(() => {
    if (menu.length > 0 && menus.length === 0) {
      const list = [...menu.slice(0, 1), {...live_menu}, ...menu.slice(1)]
      setMenus(list)
    }
  }, [menu])

  return (
    <>
      <div className="subMenu-BG">
        <div className="container H-container">
          <div className="subMenu">
            <div className="mobile">
              <img src="/ondemand/static/img/search.png" alt="" />
            </div>
            {menus.map((shelf) => {
              return (
                <div
                  onClick={() => {
                    goToPage(makeMenuUrl(shelf), null);
                  }}
                  className={makeMenuCls(shelf, page)}
                >
                  {translate(
                    shelf.setting.title_th,
                    shelf.setting.title_en,
                    authContext?.lang
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

function makeMenuUrl(shelf: BaseShelf) {
  if (shelf.setting.shelf_slug === "foryou") {
    return "/ondemand/";
  }

  if (shelf.setting.shelf_slug === "live") {
    return "/ondemand/schedule";
  }

  if (shelf.setting.type === 'by_shelfid') {
    return `/ondemand/${shelf.setting.shelf_code}`
  }

  if (shelf.setting.type === 'by_cate') {
    return `/ondemand/${shelf.setting.shelf_code}`
  }
  return `/ondemand/${shelf.setting.shelf_code}`;
}

function makeMenuCls(shelf: BaseShelf, page: string) {
  return shelf.setting.shelf_code === page ? "bold active" : "bold";
}

function makeSubMenuCls(shelf: BaseShelf, page: string) {
  return shelf.setting.shelf_code === page ? "bold active" : "bold";
}
